import { render, staticRenderFns } from "./MyTodoList.vue?vue&type=template&id=35250f43&scoped=true&"
import script from "./MyTodoList.vue?vue&type=script&lang=js&"
export * from "./MyTodoList.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoList.vue?vue&type=style&index=0&id=35250f43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35250f43",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35250f43')) {
      api.createRecord('35250f43', component.options)
    } else {
      api.reload('35250f43', component.options)
    }
    module.hot.accept("./MyTodoList.vue?vue&type=template&id=35250f43&scoped=true&", function () {
      api.rerender('35250f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/BPMeletronicSigned/MyTodoList.vue"
export default component.exports